import { ChevronDown } from '@atom-learning/icons'
import { Trigger } from '@radix-ui/react-accordion'
import React from 'react'

import {
  ColorScheme,
  TcolorScheme
} from '~/experiments/color-scheme/ColorScheme'
import { styled } from '~/styled'

import { Icon } from '../icon/Icon'

const RotatingIcon = styled(Icon, {
  base: [
    'transition-transform',
    'duration-300',
    '[[data-state=open]>&]:rotate-180',
    '[[data-state=closed]>&]:rotate-0'
  ]
})

const StyledTrigger = styled(Trigger, {
  base: [
    'border-none',
    'py-3',
    'px-4',
    'w-full',
    'flex',
    'justify-between',
    'items-center',
    'cursor-pointer',
    'bg-(--interactive-2)',
    'text-(--interactive-foreground)',
    'disabled:cursor-not-allowed',
    'disabled:opacity-30',
    'not-disabled:active:bg-(--interactive-3)',
    'not-disabled:focus-visible:bg-(--interactive-3)',
    'not-disabled:focus-visible:outline-none',
    'not-disabled:focus-visible:relative',
    'not-disabled:focus-visible:shadow-[var(--color-primary-800)_0px_0px_0px_4px]',
    'not-disabled:focus-visible:shadow-[white_0px_0px_0px_2px]',
    'not-disabled:focus-visible:z-1',
    'not-disabled:hover:bg-(--interactive-3)',
    'data-[state=open]:rounded-b-none',
    'data-[state=open]:rounded-t-sm',
    'data-[state=closed]:rounded-sm'
  ],
  variants: {
    arrowPosition: {
      left: ['flex-row-reverse', 'gap-2', 'justify-end'],
      right: []
    }
  }
})

export const AccordionTrigger = ({
  children,
  colorScheme = {},
  asChild,
  arrowPosition = 'right',
  ...remainingProps
}: React.ComponentProps<typeof StyledTrigger> & {
  colorScheme?: TcolorScheme
}) => (
  <ColorScheme asChild accent="grey1" interactive="loContrast" {...colorScheme}>
    <StyledTrigger
      asChild={asChild}
      arrowPosition={arrowPosition}
      {...remainingProps}
    >
      {asChild ? (
        children
      ) : (
        <>
          {children}
          <RotatingIcon is={ChevronDown} data-testid="accordion-chevron" />
        </>
      )}
    </StyledTrigger>
  </ColorScheme>
)
